<template>
  <div>
    <div class="left_tree">
      <a-spin :spinning="treeSpin" style="height: 100%">
        <div>
          <!-- status === 1 ? '取消经理部' : '设置经理部' -->
           <!-- qf11 -->
          <vxe-button @click="syncDeptData" style="margin:0 3px 10px 0">同步部门数据</vxe-button>
          <vxe-button style="margin: 0 3px 10px 0" v-if="status===1||status===0" @click="setDeptRegion">{{
              status === 1 ? '取消大区' : '设置大区'

            }}
          </vxe-button>
          <vxe-button style="margin: 0 0 10px 0 " v-if="status===2||status===0" @click="showDeptDealer">
            {{ status === 2 ? '取消经销商' : '设置经销商' }}
          </vxe-button>
          <vxe-button @click="download">下载模板</vxe-button>
          <a-upload
              name="file"
              :multiple="false"
              :accept="'.xlsx'"
              :action="api.comm.UPLOAD"
              :headers="{token:token}"
              :showUploadList="false"
              @change="handleChange"
              style="margin: 0 0 0 3px"
          >
            <vxe-button>导入</vxe-button>
          </a-upload>
        </div>
        <a-tree
                :show-icon="true"
                :checkStrictly="true"
                :defaultExpandAll="false"
                :defaultExpandParent="true"
                :expandedKeys.sync="defaultExpandedKeys"
                :tree-data="deptList"
                :selectedKeys="selectedKeys"
                :replaceFields="{children:'children', title:'deptName', key:'deptId', value: 'deptId' }"
                @select="onSelect"
                @check="onCheck"
        >
          <!--          :checkable="true"-->
          <a-icon type="team" slot="dealer" style="color:#2fcfeb"/>
          <a-icon type="cluster" slot="region" style="color:#52c41a"/>
        </a-tree>
      </a-spin>
    </div>
    <div class="right_table">
      <x-grid
          :id="'formList'"
          :rowId="rowId"
          :pager-config="pagerConfig"
          :form-config="formConfig"
          :url="url"
          :columns="columns"
          :other-params="{
            deptId:deptId
          }"
          :checkbox-config="checkboxConfig"
          :toolbar-config="toolbarConfig"
          :print-config="printConfig"
          :export-config="exportConfig"
          ref="grid"
          :cellClick="chooseRow"
          :cellDbClick="updateRow"
          @toolbar-addData="addRow"
          @toolbar-delData="delRow"
      >
        <template v-slot:[toolbarConfig.templatelSlots]>
          <vxe-button @click="syncUserData">同步所有用户数据</vxe-button>
          <vxe-button @click="syncDeptUserData">同步该部门用户数据</vxe-button>
          <vxe-button @click="setRole">设置角色</vxe-button>
        </template>
      </x-grid>
    </div>

    <!--明细页表单简化通用写法-->
    <formModal title="成员详情" :visible="editModalVisible">
      <detailForm :rowId="editRowId"
                  v-if="editModalVisible"
                  ref="detailForm"
                  @cancelled="closeEdit()"
                  @saved="closeEdit(true)">
      </detailForm>
    </formModal>

    <a-modal v-model="show" title="填写经销商编码" @ok="handleOk" @cancel="handleCancel">
      <span style="color: #f5222d">*</span>经销商编码:
      <a-input placeholder="请填写经销商编码" v-model="dealerNo" style="width: 200px"/>
    </a-modal>
    <a-modal
        title="选择角色"
        centered
        :maskClosable="false"
        v-model="roleModalVisible"
        @ok="roleSave"
        :width="600"
    >
      <div class="ant-row ant-form-item" v-if="roleModalVisible">
        <div class="ant-col ant-col-4 ant-form-item-label">
          <label class="ant-form-item-required">选择角色</label>
        </div>
        <div class="ant-col ant-col-18 ant-form-item-control-wrapper">
          <a-select v-model="roleId" :options="roleOption" style="width: 300px"></a-select>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {
  GridMixin,
  api,
  fac,
  mapState
} from "@/utils/common/XGridBase"

import {dataApi} from "@/services/comm/memberManage";
import {XEUtils} from "@/utils/common/FormBase";
import detailForm from "@/pages/web/comm/memberManage/memberManageDetail";
import axios from 'axios';

//列表接口
const url = api.comm.USER;

//主键
const rowId = "userId";

//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  fac.makeColumnSeqDefault(),
  fac.makeColumn("userName", "姓名", 140),
  fac.makeColumn("nickName", "昵称", 140),
  fac.makeColumn("userNo", "用户编号", 140),
  fac.makeColumn("position", "职务", 140),
  fac.makeColumn("regionName", "经理部", 140),
  fac.makeColumn("dealerName", "经销商", 120, "center"),
  fac.makeColumn("deptName", "子门店", 120, "center"),
  fac.makeColumn("mobile", "手机号", 160, "center"),
  fac.makeColumn("email", "邮箱", 160, "center"),
  fac.makeColumn("statusName", "状态", 120),
];

// 筛选条件
const formConfig = fac.makeFormConfig(columns, [
  {field: "userNo"},
  {field: "userName"},
  {field: "dealerName"},
], {
  rowNum: 3
});

//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  export: true,
  import: false,
  delData: false,
  addData: false,
  templatelSlots: "toolbarBtns",
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);


export default {
  mixins: [GridMixin],
  authorize: {
    // addRow: "ADD",
    // updateRow: 'UPDATE',
    // delRow: 'DELETE',
    // importMethod:'IMPORT',
    // exportMethod:'EXPORT',
  },
  components: {
    detailForm
    // setPassword,
  },
  computed: {
    ...mapState("account", {currUser: "user"}),
  },
  async mounted() {
    this.getDeptList().then();
    dataApi.getRoleList().then(res => {
      this.roleOption = res.data.map(item => {
        return {
          label: item.roleName,
          value: item.roleId
        }
      })
      console.log(this.roleOption)
    })
  },
  data() {
    return {
      // popConfig,
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
      checkedKeys: [],
      allList: [],
      deptList: [],
      defaultExpandedKeys: [],
      selectedKeys: [],
      deptId: '',
      treeSpin: false,
      status: 0,
      token: localStorage.getItem('token'),
      show: false,
      dealerNo: '',
      roleModalVisible: false,
      roleId: '',
      roleOption: []
    };
  },
  methods: {
    async getDeptList() {
      let deptList = await dataApi.getDeptList();
      this.allList = deptList.data;
      deptList.data.map(item => {
        if (item.isDealer) {
          return Object.assign(item, {
            slots: {
              icon: 'dealer'
            }
          })
        } else if (item.isRegion) {
          return Object.assign(item, {
            slots: {
              icon: 'region'
            }
          })
        } else {
          return item
        }
      })
      this.deptList = XEUtils.toArrayTree(deptList.data, {
        key: 'deptId',
        parentKey: 'parentId',
        children: 'children'
      })
      this.defaultExpandedKeys = deptList.data.map(val => {
        //默认只展开一级
        if (val.deptId === 1) { //已确定测试、正式系统最大一层deptId都是1
          return val.deptId
        }
      })
      console.log(this.deptList)
    },
    /**
     * 选中树
     * @param selectedKeys
     */
    onSelect(selectedKeys) {
      this.selectedKeys = selectedKeys;
      this.deptId = selectedKeys[0];

      let idx = this.allList.findIndex(item => {
        return item.deptId === this.deptId;
      })

      if (this.allList[idx].isRegion) {
        this.status = 1;
      }
      if (this.allList[idx].isDealer) {
        this.status = 2;
      }
      if (!this.allList[idx].isRegion && !this.allList[idx].isDealer) {
        this.status = 0;
      }

      this.$nextTick(() => {
        this.refresh()
      })
    },
    /**
     * 同步部门数据
     */
    async syncDeptData() {
      this.loading(true);
      this.treeSpin = true;
      let res = await dataApi.syncDeptData()
      this.loading(false);
      this.treeSpin = false;
      if (res.code === 200) {
        this.$message.success('同步成功');

        this.getDeptList().then();

      }
    },
    /**
     * 同步用户数据
     */
    async syncUserData() {
      this.loading(true);
      this.treeSpin = true;
      let res = await dataApi.syncUserData()
      this.loading(false);
      this.treeSpin = false;
      if (res.code === 200) {
        this.$message.success('同步成功');
        this.refresh()
      }
    },
    /**
     * 同步该部门用户数据
     */
    async syncDeptUserData() {
      if (this.deptId) {
        this.loading(true);
        this.treeSpin = true;
        let res = await dataApi.syncDeptUserData(this.deptId)
        this.loading(false);
        this.treeSpin = false;
        if (res.code === 200) {
          this.$message.success('同步成功');
          this.refresh()
        }
      } else {
        this.$message.warning('请选择部门');
      }
    },
    setRole() {
      let rows = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
      if (rows.length === 0) {
        this.$message.error('请选择成员')
        return false
      }
      this.roleModalVisible = true
    },
    roleSave() {
      if (!this.roleId) {
        this.$message.error('请选择角色')
        return false
      }
      let rows = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
      const arr = rows.map(item => {
        return item.userId
      })
      dataApi.batchSaveRole(arr, this.roleId).then(res => {
        if (res.code === 200) {
          this.$message.success('设置成功')
          this.refresh()
          this.roleModalVisible = false
        }
      })
    },
    /**
     * 选择复选框
     * @param checkedKeys
     */
    onCheck(checkedKeys) {
      this.checkedKeys = checkedKeys.checked;
    },
    /**
     * 设置经销商
     * @return {MessageType}
     */
    showDeptDealer() {
      if (!this.deptId) {
        return this.$message.warning('请选择部门');
      }
      if (this.status === 0) {
        this.show = true
      } else {
        this.setDeptDealer()
      }
    },
    handleOk() {
      if (this.dealerNo === '') {
        this.$message.error('请输入经销商编码')
        return false
      }
      this.setDeptDealer(this.dealerNo)
    },
    handleCancel() {
      this.dealerNo = ''
      this.show = false
    },
    async setDeptDealer(dealerNo) {
      let res = await dataApi.setDeptDealer(this.deptId, dealerNo);
      if (res.code === 200) {
        // 树局部更新

        let item = XEUtils.findTree(this.deptList, item => item.deptId === this.deptId).item

        item.isDealer === 1 ? item.isDealer = 0 : item.isDealer = 1

        if (item.isDealer) {
          Object.assign(item, {
            slots: {
              icon: 'dealer'
            }
          })
        } else {
          Object.assign(item, {
            slots: {}
          })
        }

        this.$message.success('设置成功');
        this.deptId = ''
        this.status = 0
        this.selectedKeys = [];

      }
      this.dealerNo = ''
      this.show = false
    },
    /**
     * 设置大区
     * @return {MessageType}
     */
    async setDeptRegion() {
      if (!this.deptId) {
        return this.$message.warning('请选择部门');
      }
      let res = await dataApi.setDeptRegion([this.deptId]);
      if (res.code === 200) {
        // 树局部更新
        let item = XEUtils.findTree(this.deptList, item => item.deptId === this.deptId).item

        item.isRegion === 1 ? item.isRegion = 0 : item.isRegion = 1

        if (item.isRegion) {
          Object.assign(item, {
            slots: {
              icon: 'region'
            }
          })
        } else {
          Object.assign(item, {
            slots: {}
          })
        }

        this.$message.success('设置成功');
        this.deptId = ''
        this.status = 0
        this.selectedKeys = [];
      }
    },
    download() {
      axios.get('example.xlsx', {   //静态资源文件夹public
        responseType: 'blob',
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        let fname = '经销商导入模板.xls';
        link.href = url;
        link.setAttribute('download', fname);
        document.body.appendChild(link);
        link.click();
      }).catch(error => {
        console.log('error:' + JSON.stringify(error))
      });
    },
    handleChange({file}) {
      console.log(file)
      if (file.status === 'done') {
        this.$message.success('导入成功')
        this.refresh()
      }
    }
  },
};
</script>

<style scoped lang="less">
.left_tree {
  width: 23%;
  padding: 20px;
  float: left;
  height: calc(100vh - 48px - 64px);
  border-right: 1px solid #e0e0e0;
  background: #fff;
  //overflow: hidden;
  overflow-y: auto;
}

/deep/.ant-spin-nested-loading{
  height: 100%!important;
}

.right_table {
  width: 77%;
  float: right;
  height: 100%;
}

///deep/ .ant-spin-container {
//  height: 100%;
//  display: flex;
//  flex-direction: column;
//}
///deep/ .ant-tree {
//  flex: 1;
//  overflow-y: scroll;
//}
</style>
